import React, { useEffect, useMemo, useState } from "react";

export default function BlenderTerrainUnderlay({
  href = "/research-terrain/configuration-landscape.png",
  manifestHref = "/research-terrain/configuration-landscape.manifest.json",
  opacity = 1,
}) {
  const [revision, setRevision] = useState("initial");

  useEffect(() => {
    let alive = true;
    const nonce = Date.now();

    fetch(`${manifestHref}?t=${nonce}`, { cache: "no-store" })
      .then((response) => {
        if (!response.ok) throw new Error(`manifest ${response.status}`);
        return response.json();
      })
      .then((manifest) => {
        if (!alive) return;
        setRevision(
          String(
            manifest?.render_revision ||
            manifest?.generated_at ||
            manifest?.version ||
            nonce
          )
        );
      })
      .catch(() => {
        if (alive) setRevision(String(nonce));
      });

    return () => {
      alive = false;
    };
  }, [manifestHref]);

  const imageHref = useMemo(() => {
    const separator = href.includes("?") ? "&" : "?";
    return `${href}${separator}rev=${encodeURIComponent(revision)}`;
  }, [href, revision]);

  return (
    <g
      className="rr-blender-terrain-underlay"
      pointerEvents="none"
      aria-hidden="true"
    >
      <defs>
        <clipPath id="rrBlenderLandscapeClip">
          <rect x="35" y="25" width="930" height="700" rx="46" />
        </clipPath>
      </defs>

      {/* Frontend owns the neutral backing. */}
      <rect
        x="35"
        y="25"
        width="930"
        height="700"
        rx="46"
        className="rr-blender-terrain-backing"
      />

      {/* Blender is now a transparent world layer. */}
      <image
        href={imageHref}
        x="35"
        y="25"
        width="930"
        height="700"
        preserveAspectRatio="xMidYMid slice"
        opacity={opacity}
        clipPath="url(#rrBlenderLandscapeClip)"
        className="rr-blender-world-image"
      />
    </g>
  );
}
